import React, { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Typography, Button, Table, ModalVariables, TopProgress, Label } from "../../../../components";
import {
  Container,
  ButtonsWrapper
} from './styles'
import { icons } from "../../../../icons";
import { useQueryParam, StringParam, NumberParam } from 'use-query-params';
import { affiliateService } from "../../../../api";
import { useParams } from "react-router-dom";
import { timeConverterMMDDYYHHMM } from "../../../../utils/dates";
import { useUi } from "../../../../context/ui.context";
import { compareArrays } from "../../../../utils/findIntersection";
import {
  StateWrapper,
  GreenDot,
  Greentext
} from "../../../Instances/styles";
import { handleStatusName } from "../../../../utils/handle-status-name";


type OverviewProps = {
  customers?:any
}


const Customers:FC<OverviewProps> = ({customers: initialCustomers}) => {
  const {volumeId} = useParams()
  const {viewAlert} = useUi()
  const [t] = useTranslation()
  const [page, setPage] = useQueryParam('page', NumberParam);
  const [ordering, setOrdering] = useQueryParam('ordering', StringParam);
  const [pageSize, setPageSize] = useQueryParam('page_size', NumberParam);
  const [paginationData, setPaginationData] = useState<any>()
  const [customers, setCustomers] = useState<any[]>(initialCustomers || [])
  const [loading, setLoading] = useState<boolean>(false)

  const getCustomersData = async (params?: any) => {
    try {
      setLoading(true)
      const response = await affiliateService.getCustomers(params)
      const data = response?.data
      
      if (data) {
        setPaginationData({
          count: data.count || 0,
          total_pages: data.total_pages || 0,
          pageNo: data.current_page || 1,
          page_size: data.page_size || 10
        })
        
        const formattedCustomers = data.results?.map((referral: any) => ({
          ...referral,
          customer_id: referral.user?.id,
          email: referral.user?.email,
          name: referral.user?.full_name,
          created: timeConverterMMDDYYHHMM(referral.created_at),
          region: <span style={{textTransform:'uppercase'}}>{referral.region || '-'}</span>,
          navigate: `/affiliate/customers/${referral.id}`,
          status: (<StateWrapper>
            <GreenDot active={referral.status === 'approved' ? 'true' : 'false'}/>
            <Greentext active={referral.status === 'approved' ? 'true' : 'false'}>
              {handleStatusName(referral.status, t)}
            </Greentext>
          </StateWrapper>)
        })) || []
        
        setCustomers(formattedCustomers)
      }
    } catch (e: any) {
      console.error('Error fetching customers:', e)
      viewAlert({
        severity: 'error',
        message: e?.response?.data?.detail || t("ERROR_OCCURRED")
      })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    const params = {
      page: page || 1,
      page_size: pageSize || 10,
      ordering: ordering
    }
    getCustomersData(params)
  }, [page, pageSize, ordering])

  const Columns = [
    {
      title:t("USERNAME"),
      key:'name'
    },
    {
      title:t("CREATED_AT"),
      key:'created'
    },
    {
      title:t("STATUS"),
      key:'status'
    },
    {
      title:t("CUSTOMER_ID"),
      key:'customer_id'
    },
    {
      title:t("EMAIL"),
      key:'email'
    },
    {
      title:t("REGION"),
      key:'region'
    },
  ]


  return(
    <Container>
      {
        loading ? 
          <TopProgress loading={loading}/>
        : customers.length === 0 ? 
          <>
            <Typography variant="body">{t("THERE_ARE_NO_CUSTOMERS_YET")}</Typography>
          </>
        :
          <>
            <Table
              columns={Columns}
              rows={customers}
              paginationData={paginationData}
              hideCheckbox
              updateData={getCustomersData}
              loading={loading}
              customSetPage={setPage}
              customSetPageSize={setPageSize}
              customPageSize={pageSize}
            />
          </>
      }

    </Container>
  )
}

export default Customers
